/* import __COLOCATED_TEMPLATE__ from './success-folder-recommendation-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();